import { Route, Routes } from 'react-router-dom';
import React, { useState } from 'react';
import Header from './Header';
import HeaderLogo from './HeaderLogo';
import HeaderLinks from './HeaderLinks';
import ModalCartExpire from '../ModalCartExpire';

const Headers = () => {

  const [logo, setLogo] = useState<any>('');

  return (
    <>
      <Routes>
        <Route path="/search/:search?" element={<Header />} />
        <Route path="/orders/:item_id" element={<Header />} />
        <Route path="/booking/:cart_id?" element={<HeaderLogo />} />
        <Route path="/payment/:cart_id?" element={<HeaderLogo />} />
        <Route path="/thank-you/:reservation_id" element={<HeaderLinks />} />
        <Route path="/payment-denied" element={<HeaderLogo />} />
      </Routes>
      <ModalCartExpire />
    </>
  );
};

export default Headers;
